import styled from 'styled-components'

export const ChartContainer = styled.div`
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  line-height: 45px;
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: 50%;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    width: 100%;
    line-height: 27px;
  }
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    width: 100%;
    line-height: 30px;
  }
`
export const Container = styled.div`
  display: grid;
  grid-gap: 15px;
  margin: 10px 40px 10px 40px;
  width: auto;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin: 10px 15px 10px 15px;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
export const ToolTip = styled.div`
  font-family: 'Poppins';
  font-size: 1rem;
  display: flex;
  align-items: center;
  color: #323232;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  padding: 0 10px;
`

export const ChartLabel = styled.div`
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 18px;
  padding: 10px 20px 0 20px;
  display: flex;
  align-items: left;
  justify-content: left;
`

export const ChartBlock = styled.div`
  font-size: 20px;
  padding: 20px;
  height: auto;
`
